import { useQuery } from "@tanstack/react-query";
import type { Macro } from "@/common/types/macros";
import { getMacros } from "@/services/macros";
import { useAuthStore } from "@/store/auth.store";

// The clinician's saved macros with a name, as the AI assistant offers them
// ("Insert normal cardiac exam") and "Add instruction" does while recording.
// One query (and cache) for both.
export const useMacroShortcuts = (): Macro[] => {
  const uid = useAuthStore((state) => state.user?.uid);
  const shortcuts = useQuery({
    queryKey: ["recording-shortcuts", uid],
    enabled: !!uid,
    retry: false,
    staleTime: 5 * 60 * 1000,
    queryFn: () => getMacros(uid),
  });
  return (shortcuts.data ?? []).filter((macro) => macro.name.trim());
};
